import { createContext } from 'react';

import { LocationFeatureSubscriptions } from '../hooks/location-feature-subscriptions';

const LocationFeatureSubscriptionsProviderContext = createContext<LocationFeatureSubscriptions>({} as LocationFeatureSubscriptions);

export default LocationFeatureSubscriptionsProviderContext;
